import type { CSSProperties, ReactNode } from "react";
import { cx } from "shared/utils";

export type BannerBorders =
  | "card"
  | "top"
  | "bottom"
  | "left"
  | "right"
  | "none";

export type BannerVariant =
  | "primary"
  | "success"
  | "danger"
  | "warning"
  | "base";

export type BannerButtonGroupPosition = "right" | "bottom";

export type ButtonObjectProps = {
  text: string;
  onClick?: () => void;
};
export type ButtonProps = ButtonObjectProps | ReactNode;

export function getBorderClass(borders: BannerBorders): string {
  if (borders === "none") return "";

  let borderTypeClass: string;

  if (borders === "card") borderTypeClass = "border rounded-lg";
  else if (borders === "top") borderTypeClass = "border-t";
  else if (borders === "bottom") borderTypeClass = "border-b";
  else if (borders === "left") borderTypeClass = "border-l";
  else borderTypeClass = "border-r";

  return cx(borderTypeClass, "border-alpha-100");
}

export function getBorderWidth(
  borders: BannerBorders,
  borderWidth: number
): CSSProperties | undefined {
  if (borders === "none" || borderWidth === 0 || borderWidth === 1)
    return undefined;
  if (borders === "top") return { borderTopWidth: borderWidth };
  if (borders === "bottom") return { borderBottomWidth: borderWidth };
  if (borders === "left") return { borderLeftWidth: borderWidth };
  if (borders === "right") return { borderRightWidth: borderWidth };
  return { borderWidth };
}

export function isButtonObject(
  button?: ButtonProps
): button is ButtonObjectProps {
  return !!button && typeof button === "object" && "text" in button;
}

// Literal class names so Tailwind JIT includes them.
export const BOTTOM_BUTTON_COLOR_CLASSES: Partial<
  Record<BannerVariant, { text: string; hover: string }>
> = {
  danger: { text: "!text-danger-600", hover: "hover:!text-danger-700" },
  warning: { text: "!text-warning-600", hover: "hover:!text-warning-700" },
  success: { text: "!text-success-700", hover: "hover:!text-success-800" }
};
